module.exports = __webpack_public_path__ + "h5/img/setting_logo.585ea18d.png";